{
  "INTEGRATION_APPS": {
    "FETCHING": "Integrációk lekérése",
    "NO_HOOK_CONFIGURED": "Ebben a fiókban nincs beállítva {integrationId} integráció",
    "HEADER": "Alkalmazások",
    "STATUS": {
      "ENABLED": "Engedélyezve",
      "DISABLED": "Letiltva"
    },
    "CONFIGURE": "Beállítások",
    "ADD_BUTTON": "Új hook hozzáadása",
    "DELETE": {
      "TITLE": {
        "INBOX": "Törlés megerősítése",
        "ACCOUNT": "Leválasztás"
      },
      "MESSAGE": {
        "INBOX": "Biztos abban, hogy törli?",
        "ACCOUNT": "Biztosan leválasztja?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Igen, Törlés",
        "ACCOUNT": "Igen, leválasztás"
      },
      "CANCEL_BUTTON_TEXT": "Mégse",
      "API": {
        "SUCCESS_MESSAGE": "Hook törlésre került",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      }
    },
    "LIST": {
      "FETCHING": "Integrációs hookok betöltése",
      "INBOX": "Fiók",
      "EDIT": {
        "BUTTON_TEXT": "Szerkesztés"
      },
      "DELETE": {
        "BUTTON_TEXT": "Törlés"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Válassz fiókot",
          "PLACEHOLDER": "Válassz fiókot"
        },
        "SUBMIT": "Létrehozás",
        "CANCEL": "Mégse"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrációs hookok hozzáadásra kerültek",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      }
    },
    "EDIT": {
      "TITLE": "{name} szerkesztése",
      "FORM": {
        "INBOX": {
          "LABEL": "Postafiók kiválasztása",
          "PLACEHOLDER": "Postafiók kiválasztása"
        },
        "SUBMIT": "Frissítés",
        "CANCEL": "Mégse"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrációs hook sikeresen frissítve",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a csevegőkiszolgálóhoz, kérjük, próbálja újra később"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Kapcsolódás"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Leválasztás"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Kérjen le adatokat a saját szerveréről, és jelenítse meg azokat a beszélgetés oldalsávjában. HTML-t (iframe-ben megjelenítve) vagy JSON-t (kulcs/érték listaként megjelenítve) ad vissza.",
      "DIALOGFLOW": "A Dialogflow egy természetesnyelv-feldolgozó platform beszélgetős felületek építéséhez. Ha integrálja a {installationName} rendszerrel, a botok elsőként kezelik a kérdéseket, és szükség esetén átadják őket az ügynököknek. Segít minősíteni az érdeklődőket, és a GYIK megválaszolásával csökkenti az ügynökök terhelését. A Dialogflow hozzáadásához hozzon létre egy szolgáltatásfiókot a Google Console-ban, és ossza meg a hitelesítő adatokat. A részleteket lásd a dokumentációban",
      "DAKTELA": "E-mailek és webcsevegések szinkronizálása Daktela fiókjába.",
      "RETINO": "A Retino rendet tesz a visszaküldések és reklamációk kezelésében.",
      "MAILSHIP": "A Mailship egy raktárkezelő és rendeléskezelő rendszer. Ellenőrizze a rendelés állapotát, nyomkövetési és szállítási adatait.",
      "RAYNET": "Csatlakoztassa Raynet CRM-fiókját az ügyféladatok eléréséhez. Adjon hozzá egy kapcsolatot a Raynet felhasználónevével és API-tokenjével."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Kapcsolat tesztelése",
      "SUCCESS": "Sikeres kapcsolat",
      "ERROR": "A kapcsolat sikertelen. Kérjük, ellenőrizze a hitelesítő adatokat."
    }
  }
}
